<template>
  <component :is="current" v-bind="$attrs" />
</template>

<script setup>
import { useUiWrapper } from '@/utils/uiWrapper'
import FooterViewOld from './Old/OldUploadTemplate.vue'
import NewFooterView from './New/NewUploadTemplate.vue'

const current = useUiWrapper(FooterViewOld, NewFooterView)
</script>
